const UserDetailIcon = ({ color = '#ffffff', size }) => {
	return (
		<svg
			width={size}
			viewBox="0 0 25 19"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M2.5 0.5H22.5C23.55 0.5 24.5 1.45 24.5 2.5V16.5C24.5 17.55 23.55 18.5 22.5 18.5H2.5C1.45 18.5 0.5 17.55 0.5 16.5V2.5C0.5 1.45 1.45 0.5 2.5 0.5ZM14.5 3.5V4.5H22.5V3.5H14.5ZM14.5 5.5V6.5H22.5V5.5H14.5ZM14.5 7.5V8.5H21.5V7.5H14.5ZM8.5 11.41C6.5 11.41 2.5 12.5 2.5 14.5V15.5H14.5V14.5C14.5 12.5 10.5 11.41 8.5 11.41ZM8.5 3.5C7.70435 3.5 6.94129 3.81607 6.37868 4.37868C5.81607 4.94129 5.5 5.70435 5.5 6.5C5.5 7.29565 5.81607 8.05871 6.37868 8.62132C6.94129 9.18393 7.70435 9.5 8.5 9.5C9.29565 9.5 10.0587 9.18393 10.6213 8.62132C11.1839 8.05871 11.5 7.29565 11.5 6.5C11.5 5.70435 11.1839 4.94129 10.6213 4.37868C10.0587 3.81607 9.29565 3.5 8.5 3.5Z"
				fill={color}
			/>
		</svg>
	);
};

export default UserDetailIcon;
